import { render, staticRenderFns } from "./ProductFeature.vue?vue&type=template&id=2fe2b49b&scoped=true"
import script from "./ProductFeature.vue?vue&type=script&lang=js"
export * from "./ProductFeature.vue?vue&type=script&lang=js"
import style0 from "./ProductFeature.vue?vue&type=style&index=0&id=2fe2b49b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe2b49b",
  null
  
)

export default component.exports